import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Contratos extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'contrato',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 10,
            phrase: ''
        };
    }
    componentDidMount() {
        this.refreshData();
    }
    renderForm() {
        return (
            <div>
                <div className="nk-content-body">
                    <div className="nk-block-head nk-block-head-sm">
                        <div className="nk-block-between">
                            <div className="nk-block-head-content">
                                <h3 className="nk-block-title page-title">فهرست قراردادها</h3>
                                <div className="nk-block-des text-soft">
                                    <p>شما {this.money(this.state.data.recordsCount)} قراداد ثبت شده دارید</p>
                                </div>
                            </div>
                            <div className="nk-block-head-content">
                                <div className="toggle-wrap nk-block-tools-toggle">
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="nk-block">
                        <div className="card card-bordered card-stretch">
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div class="example-alert">
                                        <div class="alert alert-pro alert-warning">
                                            <div class="alert-text">
                                                <h6>توجه</h6>
                                                <p>در حال حاضر هیچ قراردادی برای شما ثبت نشده است</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner-group">
                                    <div className="card-inner position-relative card-tools-toggle">
                                        <div className="card-title-group">
                                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                                <div className="form-inline flex-nowrap gx-3">
                                                    <div className="form-wrap">
                                                        <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="عنوان یا شناسه ملی یا شناسه حافظه مالیاتی مودی" className="form-control" />
                                                    </div>
                                                    <div className="btn-wrap">
                                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="card-inner p-0">
                                        <div className="nk-tb-list nk-tb-ulist">
                                            <div className="nk-tb-item nk-tb-head" style={{ backgroundColor: "#16498a" }}>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">ردیف</span></div>
                                                <div className="nk-tb-col"><span className="sub-text text-center text-white">کد قراداد</span></div>
                                                <div className="nk-tb-col tb-col-md"><span className="sub-text text-center text-white">نام شرکت</span></div>
                                                <div className="nk-tb-col tb-col-md"><span className="sub-text text-center text-white">نام طرف قراداد</span></div>
                                                <div className="nk-tb-col tb-col-md"><span className="sub-text text-center text-white">کد ملی</span></div>
                                                <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center text-white">شماره پرسنلی</span></div>
                                                <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center text-white">نوع قرارداد</span></div>
                                                <div className="nk-tb-col text-end"><span className="sub-text text-white">عملیات</span></div>
                                            </div>
                                            {this.state.data.records.map((record, index) =>
                                                <div className="nk-tb-item">
                                                    <div className="nk-tb-col">
                                                        <span className="sub-text text-center tb-lead">{this.genRowNumber(index)}</span>
                                                    </div>
                                                    <div className="nk-tb-col">
                                                       
                                                        <span className="sub-text text-center tb-lead">{record.id}</span>
                                                 
                                                    </div>
                                                    <div className="nk-tb-col tb-col-lg text-center">

                                                        <span class="tb-status text-warning tb-lead">{record.companyName}</span>
                                                      
                                                    </div>
                                                    <div className="nk-tb-col tb-col-md ">
                                                        <span className="sub-text text-center tb-lead">{record.personName}</span>
                                                    </div>
                                                    <div className="nk-tb-col tb-col-md ">
                                                        <span className="sub-text text-center tb-lead">{record.nationalCode}</span>
                                                    </div>
                                                    <div className="nk-tb-col tb-col-lg">
                                                        <span className="sub-text text-center tb-lead">{record.personCode}</span>
                                                    </div>
                                          
                                                    <div className="nk-tb-col tb-col-lg">
                                                        <span className="sub-text text-center tb-lead">{record.coType}</span>
                                                    </div>
                                                   
                                                    <div className="nk-tb-col nk-tb-col-tools">
                                                        <ul className="nk-tb-actions gx-1">
                                                
                                                            <li className="nk-tb-action-hidden">
                                                                <a className="btn btn-trigger btn-icon hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                                                                    <em className="icon ni ni-cross-fill-c"></em>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <div className="drodown">
                                                                    <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                    <div className="dropdown-menu dropdown-menu-end">
                                                                        <ul className="link-list-opt no-bdr">
                                                                            <li><NavLink to={"/contratomanage/edit/" + record.id + "/"}><em className="icon ni ni-eye"></em><span>مشاهده و ویرایش</span></NavLink></li>
                                                                            {/*<li><a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-na"></em><span>حذف رکورد</span></a></li>*/}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {this.createPaging()}
                                </div>
                            }
                            </div>
                    </div>
                </div>
                {!this.isBlank(this.state.Id_to_remove) &&
                    <div className="modalBg">
                        <div className="modalInner">
                            <p>آیا از حذف آیتم انتخابی مطمئن هستید؟</p>
                            <button className="btn btn-danger" onClick={e => { this.remove(); }}>بله</button>
                            <button className="btn btn-primary mr-r-10" onClick={e => { this.setState({ id_to_remove: null }); }}>انصراف</button>
                        </div>
                    </div>
                }
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : 
                    [
                        this.state.lockScreen === 1 && this.lockScreen(),
                        this.getGlobalContainer() ,
                        <Header data={this.state.data} />,
                        <div className="nk-content ">
                            <div className="container-fluid">
                                <div className="nk-content-inner">
                                    {this.renderForm()}
                                </div>
                            </div>
                        </div>,
                        <Footer />
                    ];

        return contents;
    }
}